import React from "react";
import Accordion from "react-bootstrap/Accordion";
import PaginationModified from "../../../../data/PaginationModified";
import {
  convertThenFormat,
  formatDateTimezon,
} from "../../../common-data/Converts";

const PTSaleDetailsMobile = ({
  tableData,
  tablePagination,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  setModValues,
}) => {
  function getPagination() {
    try {
      const pagination = tablePagination ? tablePagination : [];
      return pagination;
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="all-leads-log">
      {tableData?.length > 0 &&
        tableData.map((row, index) => {
          return (
            <div className="log-card" key={index}>
              <div className="all-info" style={{ rowGap: "1rem" }}>
                <div className="log-card-top">
                  <div
                    className="profile-name-number"
                    style={{
                      columnGap: "0",
                      height: "auto",
                    }}
                  >
                    <div className="name-number">
                      <h3 className="lead-name">{row?.user_name || "NA"}</h3>
                      <p className="number">{row?.user_mobile || "NA"}</p>
                      {row?.email ? (
                        <span className="value email semi-bold">
                          {row?.user_email || "NA"}
                        </span>
                      ) : null}
                    </div>
                  </div>
                </div>

                <div className="all-followuo-info-container">
                  <Accordion>
                    <Accordion.Item eventKey="0">
                      <Accordion.Header style={{ padding: "0 10px 10px 10px" }}>
                        Show More
                      </Accordion.Header>

                      <Accordion.Body>
                        <div className="lead-multi-value-cols px20px pb20px">
                          <div className="label-value">
                            <span className="label">payment type</span>
                            <span
                              className={`value ${
                                row?.is_partial ? "link" : ""
                              }`}
                              onClick={() =>
                                row?.is_partial &&
                                setModValues((prevs) => ({
                                  ...prevs,
                                  isModOpen: true,
                                  cardName: "partial_details",
                                  partialDetails: row?.payment_details || [],
                                }))
                              }
                            >
                              {row?.is_partial ? "Partial" : "Full"}
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">plan price</span>
                            <span className="value">
                              ₹{convertThenFormat(row?.plan_price || 0)}
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">
                              total amount paid during purchase
                            </span>
                            <span className="value">
                              ₹{convertThenFormat(row?.total_price || 0)}
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">full price</span>
                            <span className="value">
                              ₹{convertThenFormat(row?.total_full_price || 0)}
                            </span>
                          </div>

                          {row?.is_partial && (
                            <div className="label-value">
                              <span className="label">partial price</span>
                              <span className="value">
                                ₹
                                {convertThenFormat(
                                  row?.total_partial_price || 0
                                )}
                              </span>
                            </div>
                          )}

                          <div className="label-value">
                            <span className="label">date added</span>
                            <span className="value">
                              {row?.date_added
                                ? formatDateTimezon(row.date_added)
                                : "-"}
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">start/expire date</span>
                            <span className="value">
                              <small>
                                {row?.start_date
                                  ? formatDateTimezon(row.start_date)
                                  : "-"}
                                /
                                {row?.expire_date
                                  ? formatDateTimezon(row.expire_date)
                                  : "-"}
                              </small>
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">subscription status</span>
                            <span
                              className="value"
                              style={{
                                background:
                                  row?.subscription_status === "active"
                                    ? "#0A701B"
                                    : "#D90000",
                                color: "#fff",
                                padding: "5px",
                                borderRadius: "4px",
                              }}
                            >
                              {row?.subscription_status || "NA"}
                            </span>
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </div>
            </div>
          );
        })}

      <div className="lead-logs-card-pagination">
        <PaginationModified
          isPage={isPage}
          onChangePage={setIsPage}
          pagination={getPagination()}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
        />
      </div>
    </div>
  );
};

export default PTSaleDetailsMobile;
